export default __webpack_public_path__ + "static/media/noVacanciesIconExpanded.54efeeae.svg";